(ns common.schema.entities.exit-opportunity.permissions
  (:require [common.schema.entities.permissions :as entity-permissions]))

(defn read-permissions?
  [{:keys [account-current-permissions entity]}]
  (and (contains? (:account-modules account-current-permissions)
                  :module/exit-process-management)
       (contains? (:account-access-to-pipelines account-current-permissions)
                  (-> entity
                      :exit-opportunity/pipeline
                      :db/id))))

(defn disable-permissions?
  [ctx]
  (entity-permissions/disable-when-no-write-permission ctx))
